import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../home/components/Footer';

const projects = [
  {
    id: '01',
    name: 'Kubu Cosmetics',
    items: ['Logo Design', 'Packaging labels'],
    color: 'bg-[#d8b4fe]',
    arrowColor: 'bg-[#7c3aed]',
    textColor: 'text-[#4c1d95]',
    side: 'left',
  },
  {
    id: '02',
    name: 'Phohleli accounting and associates',
    items: ['Logo design'],
    color: 'bg-[#fda4af]',
    arrowColor: 'bg-[#e11d48]',
    textColor: 'text-[#881337]',
    side: 'left',
  },
  {
    id: '03',
    name: 'Eternity Foods',
    items: ['Enterprise blueprint', 'Business plan'],
    color: 'bg-[#5eead4]',
    arrowColor: 'bg-[#0d9488]',
    textColor: 'text-[#134e4a]',
    side: 'left',
  },
  {
    id: '04',
    name: 'Tan-I Agri Naturals',
    items: ['Company registration', 'Logo restructuring'],
    color: 'bg-[#fde68a]',
    arrowColor: 'bg-[#d97706]',
    textColor: 'text-[#78350f]',
    side: 'left',
  },
  {
    id: '05',
    name: 'Restoration Health',
    items: ['Website Development &', 'Branding'],
    color: 'bg-[#fef3c7]',
    arrowColor: 'bg-[#d97706]',
    textColor: 'text-[#78350f]',
    side: 'right',
  },
  {
    id: '06',
    name: 'Skoji Foods & herbs',
    items: ['Logo design', 'Business profile', 'Website development'],
    color: 'bg-[#a5f3fc]',
    arrowColor: 'bg-[#0891b2]',
    textColor: 'text-[#164e63]',
    side: 'right',
  },
  {
    id: '07',
    name: 'Hervefish',
    items: ['Business Proposal', 'Business case'],
    color: 'bg-[#fbcfe8]',
    arrowColor: 'bg-[#db2777]',
    textColor: 'text-[#831843]',
    side: 'right',
  },
  {
    id: '08',
    name: 'e-Kasi Flavors',
    items: ['Logo design & packaging'],
    color: 'bg-[#c4b5fd]',
    arrowColor: 'bg-[#7c3aed]',
    textColor: 'text-[#4c1d95]',
    side: 'right',
  },
];

const leftProjects = projects.filter(p => p.side === 'left');
const rightProjects = projects.filter(p => p.side === 'right');

const clientLogos = [
  {
    name: 'Kubu Cosmetics',
    tagline: 'Beauty & Skincare',
    bg: 'bg-[#f3e8ff]',
    border: 'border-[#d8b4fe]',
    text: 'text-[#6d28d9]',
    icon: 'ri-leaf-line',
  },
  {
    name: 'Phohleli',
    tagline: 'Accounting & Associates',
    bg: 'bg-[#fff1f2]',
    border: 'border-[#fda4af]',
    text: 'text-[#be123c]',
    icon: 'ri-bar-chart-2-line',
  },
  {
    name: 'Eternity Foods',
    tagline: 'Food & Nutrition',
    bg: 'bg-[#f0fdfa]',
    border: 'border-[#5eead4]',
    text: 'text-[#0f766e]',
    icon: 'ri-restaurant-line',
  },
  {
    name: 'Tan-I Agri Naturals',
    tagline: 'Agriculture & Nature',
    bg: 'bg-[#fffbeb]',
    border: 'border-[#fde68a]',
    text: 'text-[#b45309]',
    icon: 'ri-plant-line',
  },
  {
    name: 'Restoration Health',
    tagline: 'Health & Wellness',
    bg: 'bg-[#fefce8]',
    border: 'border-[#fef08a]',
    text: 'text-[#a16207]',
    icon: 'ri-heart-pulse-line',
  },
  {
    name: 'Skoji Foods & Herbs',
    tagline: 'Food & Herbal Products',
    bg: 'bg-[#ecfeff]',
    border: 'border-[#a5f3fc]',
    text: 'text-[#0e7490]',
    icon: 'ri-seedling-line',
  },
  {
    name: 'Hervefish',
    tagline: 'Aquaculture & Fisheries',
    bg: 'bg-[#fdf2f8]',
    border: 'border-[#fbcfe8]',
    text: 'text-[#9d174d]',
    icon: 'ri-water-flash-line',
  },
  {
    name: 'e-Kasi Flavors',
    tagline: 'Food & Packaging',
    bg: 'bg-[#f5f3ff]',
    border: 'border-[#c4b5fd]',
    text: 'text-[#5b21b6]',
    icon: 'ri-store-2-line',
  },
];

function ProjectCard({ project, direction }: { project: typeof projects[0]; direction: 'left' | 'right' }) {
  return (
    <div className={`flex items-center gap-0 ${direction === 'right' ? 'flex-row-reverse' : 'flex-row'}`}>
      {/* Card */}
      <div className={`${project.color} rounded-2xl px-5 py-4 min-w-[220px] max-w-[240px] shadow-sm`}>
        <p className={`font-bold text-sm leading-snug mb-2 ${project.textColor}`}>{project.name}</p>
        <ul className="space-y-0.5">
          {project.items.map((item, i) => (
            <li key={i} className={`text-xs flex items-start gap-1.5 ${project.textColor}`}>
              <span className="mt-1 w-1.5 h-1.5 rounded-full bg-current flex-shrink-0"></span>
              {item}
            </li>
          ))}
        </ul>
      </div>

      {/* Arrow connector */}
      <div className="relative flex items-center">
        {direction === 'left' ? (
          <div className={`${project.arrowColor} text-white font-bold text-sm w-12 h-12 flex items-center justify-center rounded-sm`}
            style={{ clipPath: 'polygon(0 0, 80% 0, 100% 50%, 80% 100%, 0 100%)' }}>
            {project.id}
          </div>
        ) : (
          <div className={`${project.arrowColor} text-white font-bold text-sm w-12 h-12 flex items-center justify-center rounded-sm`}
            style={{ clipPath: 'polygon(20% 0, 100% 0, 100% 100%, 20% 100%, 0 50%)' }}>
            {project.id}
          </div>
        )}
      </div>
    </div>
  );
}

export default function OurWorkPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinkClass = `text-sm font-medium tracking-wide transition-colors whitespace-nowrap cursor-pointer ${
    isScrolled ? 'text-gray-700 hover:text-[#3782df]' : 'text-gray-700 hover:text-[#3782df]'
  }`;

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white shadow-sm'
      }`}>
        <div className="w-full px-4 sm:px-8 lg:px-20 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img
                src="https://static.readdy.ai/image/3b8ad55d4ff58d61aa412f5935e39846/4f08bda5a1b03b110582211ba3bde471.png"
                alt="LumanyiTech Logo"
                className="h-10 w-auto"
              />
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link to="/" className={navLinkClass}>Home</Link>
              <Link to="/about" className={navLinkClass}>About</Link>
              <Link to="/services" className={navLinkClass}>Services</Link>
              <Link to="/our-work" className="text-sm font-medium tracking-wide text-[#3782df] whitespace-nowrap cursor-pointer">Our Work</Link>
              <Link to="/agribusiness" className={navLinkClass}>Agribusiness</Link>
              <Link to="/contact" className={navLinkClass}>Contact</Link>
            </div>
            <div className="hidden md:block">
              <Link to="/contact" className="px-6 py-2.5 bg-[#3782df] text-white rounded-full text-sm font-medium hover:bg-[#2a6bc7] transition-colors whitespace-nowrap">
                Get Started
              </Link>
            </div>
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
              aria-label="Toggle menu"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-900`}></i>
            </button>
          </div>
          {mobileMenuOpen && (
            <div className="md:hidden mt-2 pb-4 border-t border-gray-100 bg-white">
              <div className="flex flex-col gap-1 pt-3">
                {[
                  { label: 'Home', to: '/' },
                  { label: 'About', to: '/about' },
                  { label: 'Services', to: '/services' },
                  { label: 'Our Work', to: '/our-work' },
                  { label: 'Agribusiness', to: '/agribusiness' },
                  { label: 'Contact', to: '/contact' },
                ].map(item => (
                  <Link
                    key={item.label}
                    to={item.to}
                    onClick={() => setMobileMenuOpen(false)}
                    className="px-4 py-2.5 text-sm font-medium rounded-lg transition-colors text-gray-700 hover:bg-gray-50 hover:text-[#3782df]"
                  >
                    {item.label}
                  </Link>
                ))}
                <div className="px-4 pt-2">
                  <Link
                    to="/contact"
                    onClick={() => setMobileMenuOpen(false)}
                    className="block w-full text-center px-6 py-2.5 bg-[#3782df] text-white rounded-full text-sm font-medium hover:bg-[#2a6bc7] transition-colors whitespace-nowrap"
                  >
                    Get Started
                  </Link>
                </div>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Banner */}
      <div className="pt-24 pb-10 bg-gradient-to-br from-gray-50 to-white">
        <div className="w-full px-4 sm:px-8 lg:px-20 text-center">
          <span className="inline-block px-4 py-1.5 bg-[#3782df]/10 text-[#3782df] rounded-full text-xs font-semibold tracking-widest uppercase mb-4">Portfolio</span>
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4">Our Work in Action</h1>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            A showcase of the businesses and brands we've helped grow through technology, design, and strategy.
          </p>
        </div>
      </div>

      {/* Infographic Section */}
      <section className="py-16 px-4 sm:px-8 lg:px-20 bg-white">
        <div className="max-w-5xl mx-auto">
          {/* Desktop Infographic */}
          <div className="hidden md:block">
            <div className="relative flex items-start justify-center gap-0">
              {/* Left Column */}
              <div className="flex flex-col gap-10 pt-4">
                {leftProjects.map(project => (
                  <ProjectCard key={project.id} project={project} direction="left" />
                ))}
              </div>

              {/* Center Circle */}
              <div className="flex-shrink-0 mx-6 flex flex-col items-center justify-center" style={{ marginTop: '80px' }}>
                <div className="relative w-52 h-52">
                  {/* Dashed circle */}
                  <div className="absolute inset-0 rounded-full border-2 border-dashed border-gray-300"></div>
                  {/* Dots on circle */}
                  {[0, 45, 90, 135, 180, 225, 270, 315].map((deg, i) => {
                    const rad = (deg * Math.PI) / 180;
                    const r = 50;
                    const x = 50 + r * Math.cos(rad);
                    const y = 50 + r * Math.sin(rad);
                    const dotColors = ['#d8b4fe','#fda4af','#5eead4','#fde68a','#fef3c7','#a5f3fc','#fbcfe8','#c4b5fd'];
                    return (
                      <div
                        key={i}
                        className="absolute w-3 h-3 rounded-full border-2 border-white shadow"
                        style={{
                          backgroundColor: dotColors[i],
                          left: `calc(${x}% - 6px)`,
                          top: `calc(${y}% - 6px)`,
                        }}
                      ></div>
                    );
                  })}
                  {/* Center text */}
                  <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
                    <span className="text-xl font-extrabold text-gray-800 leading-tight">Our Work</span>
                    <span className="text-xl font-extrabold text-gray-800 leading-tight">in Action</span>
                  </div>
                </div>
              </div>

              {/* Right Column */}
              <div className="flex flex-col gap-10 pt-4">
                {rightProjects.map(project => (
                  <ProjectCard key={project.id} project={project} direction="right" />
                ))}
              </div>
            </div>
          </div>

          {/* Mobile Cards */}
          <div className="md:hidden grid grid-cols-1 sm:grid-cols-2 gap-4">
            {projects.map(project => (
              <div key={project.id} className={`${project.color} rounded-2xl px-5 py-4 shadow-sm`}>
                <div className="flex items-center gap-2 mb-2">
                  <span className={`${project.arrowColor} text-white text-xs font-bold w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0`}>
                    {project.id}
                  </span>
                  <p className={`font-bold text-sm leading-snug ${project.textColor}`}>{project.name}</p>
                </div>
                <ul className="space-y-0.5 pl-9">
                  {project.items.map((item, i) => (
                    <li key={i} className={`text-xs flex items-start gap-1.5 ${project.textColor}`}>
                      <span className="mt-1 w-1.5 h-1.5 rounded-full bg-current flex-shrink-0"></span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Client Logos Section */}
      <section className="py-20 bg-gray-50">
        <div className="w-full px-4 sm:px-8 lg:px-20">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 bg-[#3782df]/10 text-[#3782df] rounded-full text-xs font-semibold tracking-widest uppercase mb-4">Trusted By</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3">Our Clients</h2>
            <p className="text-gray-500 text-sm max-w-md mx-auto">Proud to have partnered with these innovative brands and businesses across Lesotho and beyond.</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-5 max-w-5xl mx-auto">
            {clientLogos.map((client, index) => (
              <div
                key={index}
                className={`${client.bg} border ${client.border} rounded-2xl px-5 py-6 flex flex-col items-center text-center gap-3 shadow-sm hover:shadow-md transition-shadow duration-200 cursor-default`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-full ${client.bg} border ${client.border}`}>
                  <i className={`${client.icon} text-2xl ${client.text}`}></i>
                </div>
                <div>
                  <p className={`font-bold text-sm leading-snug ${client.text}`}>{client.name}</p>
                  <p className="text-gray-400 text-xs mt-0.5">{client.tagline}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gradient-to-br from-[#3782df]/5 to-white">
        <div className="text-center px-4">
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-3">Ready to be our next success story?</h2>
          <p className="text-gray-500 text-sm mb-6 max-w-md mx-auto">Let's work together to bring your vision to life with the right technology and strategy.</p>
          <Link to="/contact" className="inline-block px-8 py-3 bg-[#3782df] text-white rounded-full text-sm font-semibold hover:bg-[#2a6bc7] transition-colors whitespace-nowrap">
            Start a Project
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
